export const UPDATE_LOADING = "UPDATE_LOADING";
